import useMediaQuery from '@material-ui/core/useMediaQuery'
import { RenderedFunctionComponent } from 'components/initComponents'
import { RootContainer } from 'components/RootContainer/RootContainer'
import React from 'react'

import { DesktopContact } from './DesktopContact/DesktopContact'
import { MobileContact } from './MobileContact/MobileContact'

export const ContactSection: RenderedFunctionComponent = () => {
  // TODO: somehow breakpoints are sets to material-ui
  // default values when trying to use theme ones,
  // further investigation is required
  const isMobileView = useMediaQuery('@media (max-width: 991px)')

  return (
    <RootContainer hasBackground={ false }>
      {isMobileView ? <MobileContact /> : <DesktopContact /> }
    </RootContainer>
  )
}

ContactSection.queryString = 'div.contact-section'
